import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body, Image, Initials } from './styles';
export const IconPreviewItem = ({ iconImageSource, iconImageName, iconScale, initials, initialsColor, rotation, scale = 1, xOffset, yOffset, }) => {
    return (_jsxs(Body, { style: {
            left: xOffset,
            top: yOffset,
            transform: `translate(-50%, -50%) rotateZ(${rotation || 0}deg) scale(${scale})`,
        }, children: [iconImageSource && (_jsx(Image, { alt: iconImageName ? `${iconImageName} Icon` : 'Icon Preview', src: iconImageSource, scale: iconScale ?? 1 })), initials && _jsx(Initials, { color: initialsColor, children: initials })] }));
};
//# sourceMappingURL=IconPreviewItem.js.map